import { MAX_AQI_VALUE } from "@/constants/runtime.config";
import { pxChangeVw } from "@/utils";
export default function AqiProgress({ aqi }: any) {
  const { $t } = useTranslate();
  return (
    <div className="inline-block w-40% m-[0_auto]">
      <div className="w-full h-full p-10 relative flex flex-col items-center gap-y-4">
        <div
          className="w-100 h-100 rounded-50% relative z-5"
          style={{
            background: `conic-gradient(var(--app-bg-40) ${(aqi?.Value / MAX_AQI_VALUE) * 100}%, var(--app-bg-21) 0%)`,
            mask: `radial-gradient(transparent ${pxChangeVw("35px")}, var(--app-bg-43) ${pxChangeVw("35px")})`,
          }}
        ></div>
        <div className="flex flex-col items-center gap-y-8">
          <div className="absolute text-center w-100 h-100 flex flex-col justify-center rounded-50% top-10">
            <h1 style={{ fontSize: pxChangeVw("18px") }}>{aqi?.Value}</h1>
            <p style={{ fontSize: pxChangeVw("12px"), color: "var(--app-text-29)" }}>{$t("title04")}</p>
          </div>
          <p style={{ color: "var(--app-text-27)", textAlign: "center" }}>{aqi?.Category}</p>
        </div>
      </div>
    </div>
  );
}
